import { borderosMenu } from './borderos/menu.js';
import { motAutorizadorMenu } from './mot/menu.js';

const menuAutorizadorFinanceiro = {
    label: 'Autorizador Financeiro',
    items: [borderosMenu, motAutorizadorMenu],
    rules: [...borderosMenu.rules, ...motAutorizadorMenu.rules],
};

export { menuAutorizadorFinanceiro };
